import { createSlice, current, type PayloadAction } from "@reduxjs/toolkit";
import { type INavigatesVO, leftList, secList } from "./navigateVo";
import { Grade, type IChannelVo, type IResChannelList } from "../auth/authVo";
import { createAppThunk, type IRes } from "../common";
import Http from "commons/Http";
// 이름 설정
const name = "navigates";

export interface INavigates {
  isLeft: boolean;
  mainSelected: number;
  leftList: Array<INavigatesVO>;
  secList: { [key: string]: Array<INavigatesVO> };
  leftSelected: INavigatesVO;
  newNotice: boolean;
  userProfileFlag?: boolean;

  channelList?: { id: number; text: string; value: string | number; logo?: string; type?: string }[];
  selectChannel?: { id: number; text: string; value: string | number; logo?: string; type?: string };
}

/**
 * 새로운 공지사항 여부 체크
 */
export const apiGnewNoticeCheck = createAppThunk(`${name}/apiGnewNoticeCheck`, async (_, thunkApi) => {
  const code = thunkApi.getState().auth.cp_code;
  const res = await Http.get(`notice/alarm`, { params: { code: code } });
  if (res.data.content) {
    thunkApi.dispatch(rdxNewNotice(res.data.content.data));
  }
  return res.data;
});

/**
 * 관리자가 아닌 사용자가 프로필 입력 했는지 안했는지 체크
 */
export const apiGuserProfileInfoCheck = createAppThunk(`${name}/apiGuserProfileInfoCheck`, async (_, thunkApi) => {
  const res = await Http.get(`user/info/status`);
  if (res.data) {
    thunkApi.dispatch(rdxSetUserProfileCheck(res.data.content));
  }
  return res.data;
});

// 계정 별 묶여있는 채널 리스트 조회
export const apiGChannelList = createAppThunk<IResChannelList, { type?: "PROVIDER" | "MEDIA" | "PARTNERS" }>(
  `${name}/apiGPartnerList`,
  async (param, thunkApi) => {
    const type = param.type ? param.type.toLocaleUpperCase() : null;

    const res = await Http.get<IRes<IResChannelList>>("codebook/service", {
      params: type,
    });
    if (res.data.content) {
      thunkApi.dispatch(rdxSetChannelList(res.data.content.data.list));
    }
    return res.data;
  },
);

// data 를 관리하는 reducer 설정s
const navigatesSlice = createSlice({
  name,
  initialState: {
    isLeft: true,
    leftList: leftList,
    secList: secList,
    newNotice: false,
  } as INavigates,
  reducers: {
    rdxMain(state: INavigates, action: PayloadAction<number>) {
      state.mainSelected = action.payload;
    },
    rdxIsLeft(state: INavigates, action: PayloadAction<boolean>) {
      state.isLeft = action.payload;
    },
    rdxSetLeftlist(state: INavigates, action: PayloadAction<{ grade: Grade; serviceTypeList?: string[] }>) {
      const { serviceTypeList, grade } = action.payload;
      // // serviceList의 모든 항목을 소문자로 변환하여 비교하기 위해 새로운 배열을 생성합니다.
      // const lowerServiceList = serviceTypeList?.map(service => service.toLowerCase());
      // // menu의 id가 lowerServiceList에 포함되어 있는 항목만 새로운 배열에 포함시킵니다.
      // const filteredMenu = leftList.filter(item => lowerServiceList?.includes(item.id));

      const translateFlag = serviceTypeList?.includes("TRANSLATE");
      const partnersFlag = serviceTypeList?.includes("PARTNERS");

      let list: INavigatesVO[] = [];

      if (partnersFlag) {
        list = translateFlag ? leftList : leftList.filter(i => i.id !== "translate");
      } else {
        list = translateFlag
          ? leftList.filter(i => i.id !== "partners")
          : leftList.filter(i => i.id !== "translate" && i.id !== "partners");
      }

      const setLeftList = (role: number) => {
        state.leftList = list.filter(i => {
          return i.role & role;
        });

        const subKeys = Object.keys(secList);
        subKeys.map(key => {
          state.secList[key] = secList[key].filter(i => {
            return i.role & role;
          });
        });
      };

      switch (grade) {
        case Grade.MASTER:
          setLeftList(1);
          break;
        case Grade.ADMIN:
          setLeftList(2);
          break;
        case Grade.USER:
          setLeftList(4);
          break;
        default:
          setLeftList(8);
          break;
      }
    },
    rdxNewNotice(state: INavigates, action: PayloadAction<boolean>) {
      state.newNotice = action.payload;
    },
    rdxSetUserProfileCheck(state: INavigates, action: PayloadAction<boolean>) {
      state.userProfileFlag = action.payload;
    },
    //사이드바 - 채널 선택 팝업
    rdxSetChannelList(state: INavigates, action: PayloadAction<IChannelVo[]>) {
      const list = action.payload.map((i, idx) => {
        return { id: idx + 1, text: i.name, value: i.id, logo: i.logo, type: i.type };
      });
      state.channelList = [{ id: 0, text: "모든 브랜드", value: 0 }, ...list];
    },
    //사이드바 - 채널 선택
    rdxSetChannelSelect(
      state: INavigates,
      action: PayloadAction<{ id: number; text: string; value: string | number }>,
    ) {
      state.selectChannel = action.payload.id === 0 ? undefined : action.payload;
    },
    //사이드바 - 채널 선택 팝업 리덕스 삭제
    rdxResetChannelList(state: INavigates) {
      delete state.channelList;
    },
  },
});

/**
 * CSR 에서 쓰는 액션들
 */
export const {
  rdxMain,
  rdxIsLeft,
  rdxSetLeftlist,
  rdxNewNotice,
  rdxSetUserProfileCheck,

  rdxSetChannelList,
  rdxSetChannelSelect,
  rdxResetChannelList,
} = navigatesSlice.actions;
// data 를 관리하는 reducer 기본 반환 설정
export default navigatesSlice.reducer;
